import ENV from "./env";

function getTokenDescription(tokenSymbol) {
  if (tokenSymbol in ENV.TOKEN_DESCRIPTIONS) return ENV.TOKEN_DESCRIPTIONS[tokenSymbol];
}

export { getTokenDescription };
